import { militarySituacionRepository } from "../repositories/MilitarySituacion.repository";

export const MilitarySituacionService = {
    getMilitarySituacions,
}

async function getMilitarySituacions(){
    const res = await militarySituacionRepository.getMilitarySituacions();
    return res;
}